/**
 * Sundwn Theme JavaScript
 * Sticky buy bar · FAQ accordion · Pricing toggle · Smooth scroll · Mobile menu
 */

document.addEventListener('DOMContentLoaded', function () {

  // ------------------------------------------------
  // 1. Sticky buy bar + nav scroll state
  // ------------------------------------------------
  var stickyBar   = document.getElementById('sundwn-sticky-bar');
  var heroSection = document.getElementById('hero');
  var nav         = document.getElementById('sundwn-nav');

  // Pages without a hero (e.g. the PDP) fall back to a fixed scroll threshold
  // so the sticky bar and nav-scrolled state still work everywhere.
  var stickyThreshold = heroSection ? (heroSection.offsetTop + heroSection.offsetHeight) : 480;

  function onScroll() {
    var scrollY = window.scrollY;

    // Nav: add 'nav-scrolled' class once user scrolls past hero (or threshold)
    if (nav) {
      nav.classList.toggle('nav-scrolled', scrollY > stickyThreshold);
    }

    // Sticky buy bar
    if (stickyBar) {
      stickyBar.classList.toggle('visible', scrollY > stickyThreshold);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load

  // ------------------------------------------------
  // 2. FAQ accordion
  // ------------------------------------------------
  document.querySelectorAll('.sundwn-faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = this.closest('.sundwn-faq-item');
      var isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.sundwn-faq-item').forEach(function (i) {
        i.classList.remove('open');
      });
      // Open clicked if it wasn't already open
      if (!isOpen) item.classList.add('open');
    });
  });

  // ------------------------------------------------
  // 3. (Pricing toggle removed — one-time purchase only, no subscription in this test build)
  // ------------------------------------------------

  // ------------------------------------------------
  // 4. Smooth anchor scroll with nav offset
  // ------------------------------------------------
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        var nav = document.getElementById('sundwn-nav');
        var navHeight = nav ? nav.offsetHeight : 64;
        var targetPos = target.getBoundingClientRect().top + window.scrollY - navHeight;
        window.scrollTo({ top: targetPos, behavior: 'smooth' });
      }
    });
  });

  // ------------------------------------------------
  // 5. Mobile menu (accessible: uses hidden attribute + aria-expanded)
  // ------------------------------------------------
  var hamburger   = document.getElementById('sundwn-hamburger');
  var mobileMenu  = document.getElementById('sundwn-mobile-menu');
  var menuClose   = document.getElementById('sundwn-mobile-menu-close');
  var overlay     = document.getElementById('sundwn-mobile-overlay');
  var lastFocus   = null;

  function openMenu() {
    lastFocus = document.activeElement;
    mobileMenu.removeAttribute('hidden');
    if (overlay) { overlay.style.display = 'block'; }
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    // Move focus into menu
    var firstLink = mobileMenu.querySelector('a, button');
    if (firstLink) { firstLink.focus(); }
  }
  function closeMenu() {
    mobileMenu.setAttribute('hidden', '');
    if (overlay) { overlay.style.display = 'none'; }
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocus) { lastFocus.focus(); }
  }

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', openMenu);
  }
  if (menuClose) { menuClose.addEventListener('click', closeMenu); }
  if (overlay)   { overlay.addEventListener('click', closeMenu); }

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu && !mobileMenu.hasAttribute('hidden')) { closeMenu(); }
  });

  // Close when a nav link is clicked
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

});
